module.exports = __webpack_public_path__ + "img/phone1.e10dd7e4.png";